import React from 'react';
import type { FormikHelpers } from 'formik';
import { Formik } from 'formik';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { t } from 'Src/i18n';
import { useAppContext } from 'Context/ReactAppContext';
import type { FormProduct, FormStatus, FormValues } from './productQuotationForm.utils';
import {
  FORM_STATUS,
  getFormSchema,
  getFormUser,
  getInitialFormValues,
  handleSubmit,
} from './productQuotationForm.utils';
import type { ProductQuotationFormProps } from './ProductQuotationForm';
import { ProductQuotationForm } from './ProductQuotationForm';
type ProductQuotationFormContainerProps = ProductQuotationFormProps & {
  departureCityDisabled: boolean;
  product: FormProduct;
  redirectUris: {
    success: string | null;
  };
  quotation: {
    error: FormStatus;
  };
};
type State = {
  userInfo: UserInfo;
};
export function ProductQuotationFormContainer({
  adultsOptions,
  ageIndicationAdults,
  ageIndicationKids,
  availableDatesIndication,
  agencies,
  civilityOptions,
  dateFormat,
  departureCityDisabled,
  departureCityOptions,
  departureDateOptions,
  departureDateEnd,
  departureDateStart,
  extensionOptions,
  footnotes,
  hasUser,
  isProductWithSetDates,
  isSummerCamp,
  kidsOptions,
  newsletter,
  consentOptins,
  redirectUris,
  product,
  quotation,
}: ProductQuotationFormContainerProps) {
  const appContext = useAppContext();
  const router = useRouter();
  const initialFormData = useSelector((state: State): any => {
    const { userInfo } = state;
    return getFormUser(userInfo);
  });
  return (
    <Formik
      initialStatus={{
        state: FORM_STATUS.NEW,
      }}
      initialValues={getInitialFormValues({
        departureCityDisabled,
        extensionOptions,
        isProductWithSetDates,
        isSummerCamp,
        traveler: initialFormData,
      })}
      initialTouched={
        hasUser
          ? {
              traveler: {
                civility: true,
                firstName: true,
                lastName: true,
                email: true,
                phone: true,
                gmNumber: true,
              },
            }
          : {}
      }
      validateOnMount
      validationSchema={getFormSchema(t, {
        agencies,
        civilityOptions,
        departureCityOptions,
        departureDateOptions,
        extensionOptions,
        isProductWithSetDates,
        isSummerCamp,
        locale: appContext.locale,
      })}
      onSubmit={async (values: FormValues, actions: FormikHelpers) => {
        await handleSubmit(values, {
          actions,
          appContext,
          isSummerCamp,
          newsletter,
          router,
          product,
          quotation,
          redirectUris,
        });
      }}
    >
      <ProductQuotationForm
        adultsOptions={adultsOptions}
        ageIndicationAdults={ageIndicationAdults}
        ageIndicationKids={ageIndicationKids}
        agencies={agencies}
        availableDatesIndication={availableDatesIndication}
        civilityOptions={civilityOptions}
        dateFormat={dateFormat}
        departureCityDisabled={departureCityDisabled}
        departureCityOptions={departureCityOptions}
        departureDateOptions={departureDateOptions}
        departureDateEnd={departureDateEnd}
        departureDateStart={departureDateStart}
        extensionOptions={extensionOptions}
        footnotes={footnotes}
        hasUser={hasUser}
        isProductWithSetDates={isProductWithSetDates}
        isSummerCamp={isSummerCamp}
        kidsOptions={kidsOptions}
        newsletter={newsletter}
        consentOptins={consentOptins}
        product={product}
      />
    </Formik>
  );
}
